/**
 * Convert data to CSV format and trigger download
 * @param {Array} data - Array of objects to convert
 * @param {string} filename - Name of the file
 * @param {Object} headers - Optional custom headers
 */
export const downloadAsCSV = (data, filename, headers) => {
    if (!data || !data.length) {
        throw new Error('No data to export');
    }

    // Create CSV content
    const headerRow = Object.values(headers).join(',');
    const dataRows = data.map(item => {
        return Object.keys(headers)
            .map(key => item[key])
            .join(',');
    });

    const csvContent = [headerRow, ...dataRows].join('\n');
    const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Download file
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}; 